import { render, staticRenderFns } from "./WillCall.vue?vue&type=template&id=61195736&lang=pug&"
import script from "./WillCall.vue?vue&type=script&lang=js&"
export * from "./WillCall.vue?vue&type=script&lang=js&"
import style0 from "./WillCall.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports